import { render, staticRenderFns } from "./coupon-receive.vue?vue&type=template&id=2c8901e6&scoped=true&"
import script from "./coupon-receive.vue?vue&type=script&lang=js&"
export * from "./coupon-receive.vue?vue&type=script&lang=js&"
import style0 from "./coupon-receive.vue?vue&type=style&index=0&id=2c8901e6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8901e6",
  null
  
)

export default component.exports